// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___ZFep","label":"styles_label__1ov_Q"};